import React from "react"
import autobind from "class-autobind"
import Positions from "../../../components/position/Positions"
import { IPosition, IJobDocument, EJobType } from "../../../models"
import * as api from "../../../api"
import strings from "../../../localization/strings"
interface IProps {
    readonly: boolean
    job: IJobDocument
    reloadJob(): void
}
interface IState {
    loading: boolean
    positions: IPosition[]
    clientPositions: IPosition[]
}

export default class JobDetailPositions extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            loading: true,
            positions: [],
            clientPositions: []
        }
        autobind(this)
    }

    componentDidMount() {
        api.getClientPositions(this.props.job.ClientId).then(res => {
            this.setState({ clientPositions: res.data })
            this.getPositions()
        })
    }

    getPositions(cb: Function = null) {
        api.getJobPositions(this.props.job.Id).then(res => {
            this.setState({
                positions: res.data,
                loading: false
            })
            cb && cb()
        })
    }

    render() {
        return (
            <div style={{ padding: 30 }}>
                <Positions
                    loading={this.state.loading}
                    hideAddButton={this.props.job.JobType === EJobType.NonContract && this.state.positions.length >= 1 ? true : false}
                    readonly={this.props.readonly}
                    positions={this.state.positions}
                    usablePositionLabel={strings.Client_Position}
                    usablePositions={this.state.clientPositions}
                    handleAdd={(position, cb) =>
                        api.addJobPosition(this.props.job.Id, position).then(() => {
                            this.getPositions(cb)
                            this.props.reloadJob()
                        })
                    }
                    handleUpdate={(position, cb) =>
                        api.updateJobPosition(this.props.job.Id, position).then(() => {
                            this.getPositions(cb)
                            this.props.reloadJob()
                        })
                    }
                    handleDelete={(positions, cb) =>
                        api.deleteJobPositions(this.props.job.Id, positions.map(item => item.Id)).then(() => {
                            this.getPositions(cb)
                            this.props.reloadJob()
                        })
                    }
                />
            </div>
        )
    }
}
